import { Component } from '@angular/core';
import "../../../Theme/AdminLTE/dist/js/adminlte.min.js"

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>`,
  styles: []
})
export class AppComponent { }



// WEBPACK FOOTER //
// ./src/app/components/app.component.ts